import { create } from 'zustand';

import type { UIMode } from '@/constants/ui';

type UIState = {
  mode: UIMode;
  setMode: (mode: UIMode) => void;
  init: (mode: UIMode) => void;
};

export const useUIModeStore = create<UIState>()((set) => ({
  mode: 'simple',
  setMode: (mode) => set({ mode }),
  init: (mode) => set({ mode }),
}));
